@if (vesselDetailsLoader || loadingEquip || loadingMeds || loadingDisp) {
<div class="loader text-center">
	<img src="../assets/img/loading.gif" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
<div class="card">
	<div class="card-header bg-theme">
		<h5 class="card-title pt-1 text-light mb-0">
			Medical Chest Inventory Dashboard
		</h5>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<div class="card theme-border">
					<div class="card-body">
						<div class="row g-1">
							<div class="col-3">
								<span class="text-muted fw-bold small">
									VESSEL NAME
								</span>
								<p class="fw-bold">
									{{vesselDetails?.vesselName || "-"}}
								</p>
							</div>
							<div class="col-3">
								<span class="text-muted fw-bold small">
									FLAG STATE
								</span>
								<p class="fw-bold">
									{{vesselDetails?.flagstate_name || "-"}}
								</p>
							</div>
							<div class="col-3">
								<span class="text-muted fw-bold small">
									COMPANY
								</span>
								<p class="fw-bold">
									{{vesselDetails?.company_name || "-"}}
								</p>
							</div>
							<div class="col-3">
								<span class="text-muted fw-bold small">
									LAST DELIVERY DATE
								</span>
								<p class="fw-bold">
									{{last_stock_date || "-"}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row g-1 mt-1">
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
				@if (activeTab === 0) {
				<div class="input-group input-group-sm">
					<input class="form-control" [formControl]="searchControlMed"
						placeholder="Search item, batch, or location">
					@if (searchControlMed.value) {
					<button class="btn btn-outline-secondary" type="button" (click)="clearSearchInputMed()">
						<fa-icon [icon]="['fas', 'times']"></fa-icon>
					</button>
					}
				</div>
				}@else if (activeTab === 1) {
				<div class="input-group input-group-sm">
					<input class="form-control" [formControl]="searchControlEquip"
						placeholder="Search item, batch, or location">
					@if (searchControlEquip.value) {
					<button class="btn btn-outline-secondary" type="button" (click)="clearSearchInputEquip()">
						<fa-icon [icon]="['fas', 'times']"></fa-icon>
					</button>
					}
				</div>
				}@else if (activeTab === 2) {
				<div class="input-group input-group-sm">
					<input class="form-control" [formControl]="searchControlDisp" placeholder="Search">
					@if (searchControlDisp.value) {
					<button class="btn btn-outline-secondary" type="button" (click)="clearSearchInputDisp()">
						<fa-icon [icon]="['fas', 'times']"></fa-icon>
					</button>
					}
				</div>
				}
			</div>
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-end">
				<!-- <span class="text-muted fw-bold small">
					Last Updated At:
				</span>
				<strong>
					{{lastUpdatedDateTime || "-"}}
				</strong> -->
			</div>
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-end">
				<button type="button" class="btn btn-sm btn-success" (click)="downloadInventory()">
					@if (downloadLoader) {
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','cloud-download-alt']"></fa-icon>
					}
					Download Inventory (Excel)
				</button>
			</div>
		</div>
		<!-- <div class="row g-1 mt-1">
			<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-end">
				<p class="small mb-0">
					<strong>
						<i>
							Note: We consider only medicines which are expiring after {{expiry_month}} months.
						</i>
					</strong>
				</p>
			</div>
		</div> -->
		<!-- <div class="row g-1 mt-1">
			<div class="col-2">
				<div class="ng-select-default">
					<ng-select appendTo="body" [items]="allTypes" bindLabel="name" bindValue="Id" [multiple]="false"
						[clearable]="true" placeholder="Type" [(ngModel)]="typeFilter" (change)="getList()">
					</ng-select>
				</div>
			</div>
			<div class="col-2">
				<div class="ng-select-default">
					<ng-select appendTo="body" [items]="allMonths" bindLabel="Id" bindValue="Id" [multiple]="false"
						[clearable]="true" placeholder="Expiry Month" [(ngModel)]="monthFilter"
						(change)="getList();isMonthChanged=true;">
					</ng-select>
				</div>
			</div>
			<div class="col-8">
				<mat-checkbox [(ngModel)]="showNarcotic" color="primary">
					Show Narcotic
				</mat-checkbox>
				<mat-checkbox [(ngModel)]="showDuplicate" color="primary">
					View Duplicates
				</mat-checkbox>
			</div>
		</div> -->
		<ul class="nav nav-tabs nav-tabs-bordered mb-2" role="tablist">
			<li class="nav-item" role="button" (click)="setActiveTab(0)">
				<a class="nav-link" [ngClass]="getTabClass(0)">
					MEDICINE
				</a>
			</li>
			<li class="nav-item" role="button" (click)="setActiveTab(1)">
				<a class="nav-link" [ngClass]="getTabClass(1)">
					EQUIPMENT
				</a>
			</li>
			<li class="nav-item" role="button" (click)="setActiveTab(2)">
				<a class="nav-link" [ngClass]="getTabClass(2)">
					DISPENSATION HISTORY
				</a>
			</li>
		</ul>
		<div class="tab-content">
			<div class="tab-pane" [ngClass]="getTabPaneClass(0)">
				<div class="row">
					<div class="col">
						<div class="card">
							<div class="card-body">
								@if (dtOptionsMed.pagingType) {
								<table datatable [dtOptions]="dtOptionsMed"
									class="table table-bordered table-hover table-striped" id="medicineTable">
									<thead>
										<tr>
											<th style="width: 20% !important;">3C ID</th>
											<th style="width: 40% !important;">Medicine</th>
											<th style="width: 10% !important;">Available Qty.</th>
											<!-- <th style="width: 10% !important;">Expiring Qty.(within 9 months)</th>
											<th style="width: 10% !important;">Total Req. Qty.</th> -->
											<th style="width: 10% !important;">Expired Qty.</th>
											<th style="width: 10% !important;">Flag Qty.</th>
											<th style="width: 10% !important;">Action</th>
										</tr>
									</thead>
									@if (listMed.length) {
									<tbody>
										<!-- @for (
										v of listMed | orderBy:med_order_by+'___'+med_order_type;
										track v;
										let i = $index
										){ -->
										@for (
										v of listMed;
										track v;
										let i = $index
										){
										@if (searchFromList(i,'MEDS')) {
										<tr [ngClass]="getBackgroundColor(i,'MEDS')">
											<td>{{v.medId}}</td>
											<td>{{v.med_name}}</td>
											<td>{{v.avalQty}}</td>
											<td>{{v.expiredQty}}</td>
											<!-- <td>{{v.total_required_qty}}</td> -->
											<td>{{v.flag_qty}}</td>
											<td>
												<button class="btn btn-xs btn-success"
													(click)="medicineBrandQtyExpDetails(v)">
													@if (showBatchLoader == v.id) {
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}
													View Batches
												</button>
											</td>
										</tr>
										}
										}
									</tbody>
									}@else {
									<tbody>
										<tr>
											<td colspan="6" class="text-center">
												No Items
											</td>
										</tr>
									</tbody>
									}
								</table>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane" [ngClass]="getTabPaneClass(1)">
				<div class="row">
					<div class="col">
						<div class="card">
							<div class="card-body">
								@if (dtOptionsEquip.pagingType) {
								<table datatable [dtOptions]="dtOptionsEquip"
									class="table table-bordered table-hover table-striped" id="equipmentTable">
									<thead>
										<tr>
											<th style="width: 20% !important;">3C ID</th>
											<th style="width: 50% !important;">Equipment</th>
											<th style="width: 10% !important;">Available Qty.</th>
											<th style="width: 10% !important;">Total Req. Qty.</th>
											<th style="width: 10% !important;">Action</th>
										</tr>
									</thead>
									@if (listEquipment.length) {
									<tbody>
										<!-- @for (
										v of listEquipment | orderBy:equip_order_by+'___'+equip_order_type;
										track v;
										let i = $index
										){ -->
										@for (
										v of listEquipment;
										track v;
										let i = $index
										){
										@if (searchFromList(i,'EQUIP')) {
										<tr [ngClass]="getBackgroundColor(i,'EQUIP')">
											<td>{{v.medId}}</td>
											<td>{{v.med_name}}</td>
											<td>{{v.avalQty}}</td>
											<td>{{v.total_required_qty}}</td>
											<td>
												<button class="btn btn-xs btn-success"
													(click)="medicineBrandQtyExpDetails(v)">
													@if (showBatchLoader == v.id) {
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}
													View Batches
												</button>
											</td>
										</tr>
										}
										}
									</tbody>
									}@else {
									<tbody>
										<tr>
											<td colspan="5" class="text-center">
												No Items
											</td>
										</tr>
									</tbody>
									}
								</table>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane" [ngClass]="getTabPaneClass(2)">
				<div class="row">
					<div class="col">
						<div class="card">
							<div class="card-body">
								@if (dtOptionsDisp.pagingType) {
								<table datatable [dtOptions]="dtOptionsDisp"
									class="table table-bordered table-hover table-striped" id="dispensationTable">
									<thead>
										<tr>
											<th style="width: 10% !important;">Date</th>
											<th style="width: 25% !important;">Medicine</th>
											<th style="width: 25% !important;">Name</th>
											<th style="width: 10% !important;">Quantity</th>
											<th style="width: 30% !important;">Notes</th>
										</tr>
									</thead>
									@if (listDispensation.length) {
									<tbody>
										@for (
										v of listDispensation;
										track v;
										let i = $index
										){
										<tr>
											<td>{{v.log_date}}</td>
											<td>{{v.med_name}}</td>
											<td>{{v.recepient_name}}</td>
											<td>{{v.quantity}}</td>
											<td>{{v.notes}}</td>
										</tr>
										}
									</tbody>
									}@else {
									<tbody>
										<tr>
											<td colspan="5" class="text-center">
												No Items
											</td>
										</tr>
									</tbody>
									}
								</table>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="batchDetailsModalDash" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<b>{{boxMed}}</b>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearBatchModal()">
				</button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-md-12">
						@if(batchList.length){
						<table class="table">
							<tbody>
								@for (
								x of batchList;
								track x;
								let i = $index
								) {
								<tr>
									<td>
										<div class="row mb-2">
											<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
												@if (x.img_file) {
												<a href="{{mediaURL+x.img_file}}" target="_blank"
													matTooltip="Click to view full image">
													<img src="{{mediaURL+x.img_file}}" alt="Medicine image"
														class="med-image" />
												</a>
												}
											</div>
											<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
												<label class="text-muted fw-bold small">Brand Name:</label>
												<p class="fw-bold">{{x.brand_name}}</p>
											</div>
											<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
												<label class="text-muted fw-bold small">Batch No.:</label>
												<p class="fw-bold">{{x.batch_no}}</p>
											</div>
											<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
												<label class="text-muted fw-bold small">Batch Expiry:</label>
												<p [ngClass]="x.flag?'text-danger':''" class="fw-bold">
													{{x.batch_exp}}
												</p>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
												<label class="text-muted fw-bold small">Batch Qty:</label>
												<br />
												@if (enableFields) {
												<div class="row g-1">
													<div class="col-6">
														<input type="number" class="form-control" id="batch_qty{{i}}"
															[(ngModel)]="x.batch_qty"
															[ngModelOptions]="{standalone: true}"
															[ngStyle]="getStyle(i)"
															(ngModelChange)="batchFormChanged(i)"
															max="{{x.batch_qty_original}}" />
													</div>
													<div class="col-6 pt-2">
														<button type="button" class="btn btn-xs btn-primary"
															(click)="minusQty(i)">
															<fa-icon [icon]="['fas','minus']"></fa-icon>
														</button>
														<!-- <button type="button" class="btn btn-xs btn-info ms-1"
															(click)="addQty(i)">
															<fa-icon [icon]="['fas','plus']"></fa-icon>
														</button> -->
													</div>
												</div>
												}@else {
												<p class="fw-bold">{{x.batch_qty}}</p>
												}
											</div>
										</div>
										@if (x.batch_qty_original != x.batch_qty && x.batch_qty_original > x.batch_qty){
										<div class="row mb-2">
											<div class="col-9">
												<div class="form-floating">
													<input class="form-control" [value]="boxMed" [readOnly]="true"
														placeholder="">
													<label>Medicine Name*</label>
												</div>
											</div>
											<div class="col-3">
												<div class="form-floating">
													<input class="form-control" [value]="x.cons_qty" [readOnly]="true"
														placeholder="">
													<label>
														Quantity/Dosage*
														<!-- @if (x.batch_qty_original > x.batch_qty) {
														Quantity/Dosage*
														}@else if (x.batch_qty > x.batch_qty_original) {
														Add Batch Quantity*
														} -->
													</label>
												</div>
											</div>
										</div>
										}
										@if (x.batch_qty_original > x.batch_qty) {
										<div class="row mb-2">
											<div class="col-3">
												<label>Cause*</label>
												<mat-radio-group [(ngModel)]="x.cause"
													[ngModelOptions]="{standalone: true}">
													<mat-radio-button [value]="'med_case'" [color]="'primary'">
														Medical Use
													</mat-radio-button>
													<mat-radio-button [value]="'is_dispose'" [color]="'primary'">
														Dispose
													</mat-radio-button>
												</mat-radio-group>
											</div>
											<div class="col-3">
												<div class="input-group">
													<div class="form-floating">
														<input class="form-control" placeholder=""
															[(ngModel)]="x.log_date"
															[ngModelOptions]="{standalone: true}" ngbDatepicker
															#log_date="ngbDatepicker" [minDate]="minDate"
															[maxDate]="maxDate" [container]="'body'" />
														<label>Date*</label>
													</div>
													<button class="btn btn-outline-secondary"
														(click)="log_date.toggle()" type="button">
														<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
													</button>
												</div>
											</div>
											@if (x.cause == 'med_case') {
											<div class="col-6">
												<div class="form-floating">
													<input class="form-control" [(ngModel)]="x.recepient_name"
														[ngModelOptions]="{standalone: true}" placeholder=""
														maxlength="{{maxRecipientName}}">
													<label>Name*</label>
												</div>
												<small class="text-muted ms-2">
													{{ (x.recepient_name?.length || 0) }} / {{maxRecipientName}}
												</small>
											</div>
											}
										</div>
										@if (x.cause == 'med_case') {
										<div class="row mb-2">
											<div class="col-6">
												<div class="form-floating">
													<input class="form-control" [(ngModel)]="x.rank"
														[ngModelOptions]="{standalone: true}" placeholder="">
													<label>Rank</label>
												</div>
											</div>
											<div class="col-6">
												<div class="form-floating">
													<input class="form-control" [(ngModel)]="x.nationality"
														[ngModelOptions]="{standalone: true}" placeholder="">
													<label>Nationality</label>
												</div>
											</div>
										</div>
										}
										<div class="row mb-2">
											<div class="col">
												<div class="form-floating">
													<textarea class="form-control" [(ngModel)]="x.stock_notes"
														[ngModelOptions]="{standalone: true}" placeholder=""
														maxlength="{{maxNotes}}"></textarea>
													<label>Notes</label>
												</div>
												<small class="text-muted ms-2">
													{{ (x.stock_notes?.length || 0) }} / {{maxNotes}}
												</small>
											</div>
										</div>
										<div class="row mb-2">
											<div class="col">
												<button type="button" class="btn btn-md btn-success w-100"
													(click)="logDispensation(i)" [disabled]="showBatchSaveLoader == i">
													@if (showBatchSaveLoader == i) {
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}
													Log Dispensation
												</button>
											</div>
										</div>
										}@else if (x.batch_qty > x.batch_qty_original) {
										<!-- <div class="row mb-2">
											<div class="col-6">
												<div class="form-floating">
													<input class="form-control" [(ngModel)]="x.BrandName"
														[ngModelOptions]="{standalone: true}" placeholder="">
													<label>Brand Name*</label>
												</div>
											</div>
											<div class="col-3">
												<div class="form-floating">
													<input class="form-control" [(ngModel)]="x.BatchNo"
														[ngModelOptions]="{standalone: true}" placeholder="">
													<label>Batch No.*</label>
												</div>
											</div>
											<div class="col-3">
												<div class="input-group">
													<div class="form-floating">
														<input class="form-control" placeholder=""
															[(ngModel)]="x.BatchExpDate"
															[ngModelOptions]="{standalone: true}" ngbDatepicker
															#batch_exp_date="ngbDatepicker" [minDate]="minDate"
															[container]="'body'" />
														<label>Batch Expiry Date*</label>
													</div>
													<button class="btn btn-outline-secondary"
														(click)="batch_exp_date.toggle()" type="button">
														<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
													</button>
												</div>
											</div>
										</div>
										<div class="row mb-2">
											<div class="col">
												<button type="button" class="btn btn-md btn-success w-100"
													(click)="addBatchQty(i)" [disabled]="showBatchSaveLoader == i">
													@if (showBatchSaveLoader == i) {
													<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
													}
													Add Medicine
												</button>
											</div>
										</div> -->
										}
									</td>
								</tr>
								}
							</tbody>
						</table>
						}@else{
						<p class="text-center">No data found</p>
						}
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-info" data-bs-dismiss="modal" (click)="clearBatchModal()">
					Close
				</button>
			</div>
		</div>
	</div>
</div>